<template>
  <div v-on="$listeners">
    <r-icon name="delete" :class="`text-${color}`" size="20px" class="cursor-pointer" />
  </div>
</template>

<script>
import RIcon from '@/components/base/RIcon';

export default {
  name: 'TrashIcon',
  components: { RIcon },
  props: {
    color: {
      type: String,
      default: 'riseup-blue',
    },
  },
};
</script>
